import { getClient } from "./client";

export const recordGameEntry = (gameId: string) =>
  getClient({ authenticate: true }).post(`/api/games/${gameId}/participant`);
